import { useCallback } from 'react'

import { Document } from '@/features/library/types/document'

import { normalize } from './normalize'
import { shouldSendOnce, throttleOncePer } from './shouldSendOnce'
import { useAnalytics } from './useAnalytics'

export function useLibraryAnalytics() {
  const { track } = useAnalytics()

  const trackDocumentViewed = useCallback(
    (document: Document) => {
      if (shouldSendOnce('document_viewed', document.id, 30 * 60 * 1000)) {
        track.document.viewed({
          ...normalize.document(document, 'library'),
          document_type: document.archive_kind,
          has_rewards: !!(document.coin_reward || document.point_reward),
          context_route: window.location.pathname
        })
      }
    },
    [track]
  )

  const trackDocumentDownloaded = useCallback(
    (document: Document) => {
      track.document.downloaded({
        ...normalize.document(document, 'library'),
        document_type: document.archive_kind,
        coin_reward: document.coin_reward,
        point_reward: document.point_reward,
        context_route: window.location.pathname
      })
    },
    [track]
  )

  const trackContentSearched = useCallback(
    (query: string, resultsCount: number) => {
      track.searched(query, resultsCount, 'library')
    },
    [track]
  )

  return {
    trackDocumentViewed,
    trackDocumentDownloaded,
    trackContentSearched
  }
}
